import { PublicClientApplication, AuthenticationResult, LogLevel, AccountInfo, InteractionRequiredAuthError } from "@azure/msal-browser"

export const msalConfig = {
    auth: {
      clientId: process.env.VUE_APP_MSAL_CLIENTID ?? '',
      authority: process.env.VUE_APP_MSAL_AUTHORITY,
      redirectUri: '/' + process.env.VUE_APP_NAME + '/auth',
      navigateToLoginRequestUrl: true,

    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
      secureCookies : true
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    system: {
      loggerOptions: {
        level: LogLevel.Warning,
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              //console.info(message);
              return;
            case LogLevel.Verbose:
              //console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        }
      }
    }
  
  
  }

export class AuthService {
    
    private msalInstance : PublicClientApplication
    private accessToken : AuthenticationResult["accessToken"] | undefined

    public username : AccountInfo['username'] | undefined // used to identify active account - when multiple accounts are logged in

    constructor() { 
      this.msalInstance = new PublicClientApplication(msalConfig)
    }

    public async loadAuthModule(){
      await this.msalInstance.initialize()
      await this.msalInstance.handleRedirectPromise()
        .then((response: AuthenticationResult | null) => {
          
          if(response === null)
            this.login(this.username)
          else 
            this.handleResponse(response)

        }).catch(console.error)
      
    }
    public async login(username : AccountInfo['username'] | undefined) {

      if(typeof username == 'undefined'){  //initially the username is set to undefined
        const cached_account = this.getAccount()

        if(typeof cached_account == 'undefined') {
          await this.msalInstance.loginRedirect(loginRequest)
          return  // loginRedirect will reload page, but need a return/throw to appease linting
        }

        username = cached_account?.username
      }

      const account = this.msalInstance.getAccountByUsername(username)
      const SilentRequest = (account) ? { account: account,  ...loginRequest } : { loginHint: username, ...loginRequest }
 
      await this.msalInstance.ssoSilent((SilentRequest))
        .then((response) => {
          this.handleResponse(response)
        })
        .catch((err) => {
          console.log(err)
          if (err instanceof InteractionRequiredAuthError) {
            this.msalInstance.loginRedirect(loginRequest)
          }
        })
    }

    private async handleResponse(response: AuthenticationResult | undefined) {        
        const account = response?.account ?? this.getAccount()
        this.username = (account?.username) ?? undefined
        await this.acquireAccessToken()
    }

    public getAccount(): AccountInfo | undefined {
      const accounts = this.msalInstance.getAllAccounts()
      if (accounts === null || accounts.length == 0) return undefined
      return accounts.find((account) => account.username == this.username) ?? accounts[0]
    }

    public getAccountsUserNames() : AccountInfo['username'][] {
      const accounts = this.msalInstance.getAllAccounts()
      return accounts.map((account) => account.username)
    }

    public async acquireAccessToken() {
      const account = this.getAccount()
      
      if(typeof account == 'undefined'){
        console.log("Error : Account object not set")
        return  // if for some reason the account is not set, exit 
      }

      const accessTokenRequest = { scopes : [msalConfig.auth.clientId + "/.default", 'offline_access'], account: account }
      
      return this.msalInstance
        .acquireTokenSilent(accessTokenRequest)
        .then(response => {
            this.accessToken = response.accessToken
        })
        .catch(error => {
            if (error instanceof InteractionRequiredAuthError) {
                //sessionStorage.clear()
                this.msalInstance.acquireTokenRedirect({ ...accessTokenRequest })
            }
            console.log(error)
        })
    }
}

export const msalInstance = new PublicClientApplication(msalConfig);

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ['User.Read'],
  };
  
  // Add here the endpoints for MS Graph API services you would like to use.
  export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  };